import columns from './statistics-columns';

export default () => ({
    columns: [
        columns.processor,
        columns.category,
        { ...columns.count, headerName: 'No. of Loads' },
        columns.amount,
        columns.scc_average,
        columns.fat_average,
        columns.fat_weight,
        columns.protein_average,
        columns.protein_weight,
        columns.other_solids_average,
        columns.other_solids_weight,
        // wrap
    ],
});
